export default "__VITE_ASSET__FHvaHTiA__"